import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/authSlice";
import postReducer from "./post-requirement/postRequirementSlice";
import locationReducer from "./common/locationSlice";
import profileReducer from "./profile/profileSlice";
import trackerReducer from "./internal-tracking/InternalTrackerSlice";
import workauthoReducer from "./common/workAuthorizationSlice";
import trackersubmissionReducer from "./internal-tracking/InternalSubmissionSlice";
import feedbackReducer from "./feedback/feedbackSlice";
import helpdeskReducer from "./helpdesk/helpdeskSlice";
import skillReducer from "./common/skillSlice";
import jobtimelineReducer from "./jobTimeline/jobTimelineSlice";
import massmailReducer from "./massmail/massmailSlice";
import candidateReducer from "./candidate/candidateSlice";
import staticReducer from "./static/staticSlice";
import inviteReducer from "./invite/inviteSlice";
import creditReducer from "./credit/creditSlice";
import bugsReducer from "./bugs/bugSlice";
import hotListReducer from "./hotlist/hotListSlice";
import hotListRecReducer from "./hotlist/hotListRecSlice";

import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import internalCandidateStaticSlice from "./InternalStatic/internalCandidateStatic";
import internalCandidateStaticValueSlice from "./internalCandidateStaticValue/internalCandidateStaticValue";

const persistConfig = {
  key: "root", // Key for storage
  storage, // Use localStorage
};

const persistConfigCandidate = {
  key: "candidate", // Key for storage
  storage, // Use localStorage
};

const persistConfigCandidateInternal = {
  key: "candidate", // Key for storage
  storage, // Use localStorage
};

const persistedReducer = persistReducer(persistConfig, staticReducer);
const persistedInternalCandidateReducer = persistReducer(
  persistConfigCandidate,
  internalCandidateStaticSlice
);

const persistedInternalCandidateReducerInternal = persistReducer(
  persistConfigCandidateInternal,
  internalCandidateStaticValueSlice
);

export const store = configureStore({
  reducer: {
    auth: authReducer,
    postrequirement: postReducer,
    location: locationReducer,
    profile: profileReducer,
    tracker: trackerReducer,
    workautho: workauthoReducer,
    trackersubmission: trackersubmissionReducer,
    feedback: feedbackReducer,
    helpdesk: helpdeskReducer,
    skill: skillReducer,
    // benchsales redux
    jobtimeline: jobtimelineReducer,
    candidate: candidateReducer,
    massmail: massmailReducer,
    static: persistedReducer,
    invite: inviteReducer,
    credit: creditReducer,
    bugs: bugsReducer,
    hotlist: hotListReducer,
    hotlistrec: hotListRecReducer,
    internalCandidateStatic: persistedInternalCandidateReducer,
    internalCandidateStaticValue: persistedInternalCandidateReducerInternal,
  },
});

export const persistor = persistStore(store);
